import React, { useState } from "react";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

const images = [
  "https://api.v2.rahebehesht.com/file/get/1_1741164997.jpg",
  "https://api.v2.rahebehesht.com/file/get/2ـ_1741167889.jpg",
  "https://api.v2.rahebehesht.com/file/get/3_1741167908.jpg",
  "https://api.v2.rahebehesht.com/file/get/4_1741165031.jpg",
  "https://api.v2.rahebehesht.com/file/get/5_1741165038.jpg",
];

const CompressEducationSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentIndex(index);
    setIsOpen(true);
  };

  const closeLightbox = () => {
    setIsOpen(false);
  };

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className="gallery-container">
      {images.map((image, index) => (
        <img
          key={index}
          src={image}
          alt={`Image ${index + 1}`}
          className="gallery-image"
          onClick={() => openLightbox(index)}
        />
      ))}

      {isOpen && (
        <Lightbox
          mainSrc={images[currentIndex]}
          nextSrc={images[(currentIndex + 1) % images.length]}
          prevSrc={images[(currentIndex + images.length - 1) % images.length]}
          onCloseRequest={closeLightbox}
          onMovePrevRequest={prevSlide}
          onMoveNextRequest={nextSlide}
        />
      )}

      <style jsx>{`
        .gallery-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 10px;
        }
        .gallery-image {
          width: 100%;
          margin-block: 16px;
          border-radius: 10px;
          cursor: pointer;
          transition: transform 0.3s ease-in-out;
        }
        .gallery-image:hover {
          transform: scale(1.03);
        }
      `}</style>
    </div>
  );
};

export default CompressEducationSlider;
